/**
 * KAN-877: кому позвонит кнопка "Позвонить".
 *
 *   GET /api/v1/clients/{id}/call-targets/  - {targets: [{target, name, role, phone}]}
 *       первый - адресат карточки, дальше ЛПР (если его номер другой) и
 *       контакт по рекомендации; [] - набирать нечего.
 *
 * Выбранный target передаётся в POST manager-call (services/api/managerCall).
 * Отдельный модуль, чтобы моки managerCall в старых тестах не теряли экспорт.
 */
import apiClient from './client';

export type CallTargetKind = 'client' | 'decision_maker' | 'referral';

export interface CallTarget {
  target: CallTargetKind;
  name: string;
  role: string;
  phone: string;
}

/** Путь списка адресатов (им же проверяется доступ менеджера). */
export function callTargetsUrl(clientId: string): string {
  return `/api/v1/clients/${clientId}/call-targets/`;
}

export async function fetchCallTargets(clientId: string): Promise<CallTarget[]> {
  const res = await apiClient.get<{ targets?: CallTarget[] }>(callTargetsUrl(clientId));
  return res.data?.targets ?? [];
}
